"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgPentagon = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12.497 1.548a2 2 0 0 0-.994 0c-.378.097-.701.334-.959.522l-.071.053-8.119 5.892-.072.052c-.26.186-.585.42-.794.75a2 2 0 0 0-.308.947c-.025.39.101.771.201 1.075l.028.084 3.1 9.531.027.085c.098.304.22.685.47.986.214.26.49.46.804.585.363.143.764.142 1.083.14h10.214c.32.002.72.003 1.083-.14.313-.124.59-.325.805-.585.249-.3.371-.682.469-.986l.027-.085 3.1-9.53.028-.085c.1-.304.226-.685.201-1.075a2 2 0 0 0-.308-.947c-.21-.33-.535-.564-.794-.75l-.072-.052-8.119-5.892-.071-.053c-.258-.188-.58-.425-.959-.522Z", fill: "currentColor" }) }))); };
exports.default = SvgPentagon;
